import { InfoOutlined } from '@mui/icons-material'
import { Box, Button, Fade, Grid, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { toggleFormOffer } from '../../../../../redux/actions/offers'
import CustomChip from '../../../../shared/components/CustomChip'
import AdminContentFilter from '../../../../shared/components/filters/AdminContentFilter'
import CountriesFilter from '../../../../shared/components/filters/CountryFilter'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { tableScreenStyles } from '../../../../shared/styles/TableScreenStyles'

interface OffersHeaderProps {
  optionsData: Array<{
    data: Array<{ id: number; name: string }>
    code: string
    column: string
  }>
  handleClickSetOptions: (options: any) => void
}

const OffersHeaderFilters = ({ optionsData, handleClickSetOptions }: OffersHeaderProps) => {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const theme = useTheme()
  const classes = tableScreenStyles(theme)
  const dispatch = useDispatch()

  return (
    <Box mt={isMobile ? 2 : 6} gap={2} display="flex" flexDirection={isMobile ? 'column-reverse' : 'column'}>
      <Box display="flex" justifyContent="center">
        <Typography variant="h5" align="center">
          {t('all')}
        </Typography>
        <Tooltip
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 600 }}
          arrow
          title={
            <Box>
              <Typography variant="body2">{t('status')}:</Typography>
              <Box display="flex" gap={1} alignItems="center">
                <CustomChip size="small" color={'primary'} />
                <Typography variant="caption">{t('active')}</Typography>
              </Box>
              <Box display="flex" gap={1} alignItems="center">
                <CustomChip size="small" color={'secondary'} />
                <Typography variant="caption">{t('inactive')}</Typography>
              </Box>
            </Box>
          }
        >
          <IconButton>
            <InfoOutlined sx={{ color: '#8F99A3' }} fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Box>
        <Grid container justifyContent="space-between" spacing={1}>
          <Grid item xs={5} sm={6} sx={classes.actionsResponsive}>
            <Button variant="outlined" color="secondary" onClick={() => dispatch(toggleFormOffer(true))}>
              {t('create-offer')}
            </Button>
          </Grid>
          <Grid item xs={7} sm={6} sx={classes.actionsResponsiveRight}>
            <AdminContentFilter data={optionsData} handleClick={handleClickSetOptions} />
            <CountriesFilter />
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default OffersHeaderFilters
